import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"
import { LoginRouting } from "./access/login/login-routing"
import { MaintenanceRouting } from "./access/maintenance/maintenance-routing"
import { ResetPasswordConfirmRouting } from "./access/reset-password-confirm/reset-password-confirm-routing"
import { ResetPasswordRequestRouting } from "./access/reset-password-request/reset-password-request-routing"
import { CustomerAreaRoutes } from "./customer-area/customer-area-routing"

const routes: Routes = [
  { path: '', redirectTo: 'escli', pathMatch: 'prefix' },
  CustomerAreaRoutes,
  LoginRouting,
  ResetPasswordConfirmRouting,
  ResetPasswordRequestRouting,
  MaintenanceRouting
]

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }
